import script from "./water-access-item.vue?vue&type=script&setup=true&lang=ts"
export * from "./water-access-item.vue?vue&type=script&setup=true&lang=ts"

import "./water-access-item.vue?vue&type=style&index=0&id=f8eb126a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8eb126a"]])

export default __exports__